import { Injectable } from '@angular/core';
import { CallNumber } from '@ionic-native/call-number';
import { Platform } from 'ionic-angular';
import { UtilsProvider } from '../../providers/myria/utils-provider';
import { APP_CONFIG } from '../../environment';
import { COUNTRY_SETTINGS } from '../../providers/myria/app-variables';
import { AnalyticsEventType, ContactType } from '../../model/types/analytics.const';
import { SegmentProvider } from '../../providers/analytics/segment';



@Injectable()
export class CallProvider {

  constructor(
    private call: CallNumber,
    private platform: Platform,
    private analytics: SegmentProvider,
    private utils: UtilsProvider
  ) {}

  async callCustomerService(location ?: string, reason = '') {
    if(location)
      this.trackCallEvent(location, reason);
    const setting = await this.utils.hasCountrySettingByPromise(APP_CONFIG.region.regionId, COUNTRY_SETTINGS.CUSTOMERS_SERVICE_NUMBER);
    this.callNumber(setting);

  }

  trackCallEvent(location, reason = '') {
    this.analytics.trackEvent({eventName: AnalyticsEventType.ContactButtonClicked, analyticsData: {
      location: location,
      reason: reason,
      contactType: ContactType.Call
    }});
  }

  callNumber (phone: string, byPassAppChooser: boolean = true, location ?: string, reason = '') {
    if(location)
      this.trackCallEvent(location, reason);
    if (this.platform.is('cordova') && this.platform.is('ios'))
      this.call.callNumber(phone, byPassAppChooser);
    else
      window.location.href = `tel:${phone}`;
  }
}



// WEBPACK FOOTER //
// ./src/providers/call/call.ts